import React from 'react';
import { SelectItem as KSelectItem, } from '@ui-kitten/components';
export const Kitten = (props) => {
    const { ...rest } = props;
    return (<KSelectItem {...rest}/>);
};
export default {
    Kitten,
};
//# sourceMappingURL=SelectItem.js.map